export const theme = {
  articleTypeColor: "#ffca05",
};

export type ThemeType = typeof theme;
